<template>
	<main class="app-main">
		<div class="content-wrap">
			<section class="content-section">
				<header class="section-header">
					<h2 class="section-title">{{ $t('routes.payments.title') }}</h2>
				</header>
				<article>
					<actions-panel>
						<button class="button style-3" @click.stop.prevnet="$store.commit('SHOW_PAYMENT_CREATE_FORM')">
							<span class="inner">{{ $t('payments.add_payment') }}</span>
						</button>
						<router-link :to="$t('routes.home.path')" class="button style-1">
							<span class="inner">{{ $t('general.back') }}</span>
						</router-link>
					</actions-panel>
					<chart-finance-panels-group :charts-data="chartsData"
					                            :finance-panels-data="financePanelsData"
					                            :title="$t('payments.payments_list')"
					                            v-if="financePanelsData.length"/>
					<p v-else>{{ $t('payments.no_payments') }}</p>
				</article>
			</section>
		</div>
	</main>
</template>

<script>


import ActionsPanel from "@/components/panels/ActionsPanel";
import ChartFinancePanelsGroup from "@/components/containers/ChartFinancePanelsGroup";
import investmentsMixin from "@/mixins/investmentsMixin";

export default {
	name: "Payments",
	mixins: [investmentsMixin],
	components: {
		ActionsPanel,
		ChartFinancePanelsGroup
	},
	data() {
		return {
			type: 'monthly'
		}
	},
	computed: {
		financePanelsData(){
			let data = [];
			this.$store.state.views.payments.forEach((item) => {
				data.push({
					id: item.id,
					icon: item.icon,
					name: item.name,
					value: this.type === 'monthly' ? item.monthly_amount : item.yearly_amount,
					type: item.type,
					finance_type: 'payment'
				});
			});

			return data;
		},
		chartsData() {
			let data = [
				this.getPortfoliosChartOptions(),
			];

			let groups = {};

			this.$store.state.views.payments.forEach((item) => {
				let monthlyValue = parseFloat(item.monthly_amount);
				let yearlyValue = parseFloat(item.yearly_amount);
				if(!groups[item.group]) {
					groups[item.group] = {
						monthly: 0,
						yearly: 0,
					};
				}

				groups[item.group].monthly += monthlyValue;
				groups[item.group].yearly += yearlyValue;
			});

			let labels = [];
			let monthlySeries = [];
			let yearlySeries = [];

			Object.entries(groups).forEach(([key, value]) => {
				labels.push(key);
				monthlySeries.push(value.monthly);
				yearlySeries.push(value.yearly);
			});

			data[0].toggleSeries = true;
			data[0].seriesLabel_1 = this.$t('forms.monthly');
			data[0].seriesLabel_2 = this.$t('forms.yearly');
			data[0].chartOptions.labels = labels;

			if(this.type === 'monthly'){
				data[0].series = monthlySeries;
			} else {
				data[0].series = yearlySeries;
			}

			return data;
		},
	},
	methods: {
		processSeriesSwitcherChange(data){
			this.type = data.value ? 'yearly' : 'monthly';
		}
	},
	mounted() {
		this.$root.$on('series-switcher-change', this.processSeriesSwitcherChange)
	},
	destroyed() {
		this.$root.$off('series-switcher-change', this.processSeriesSwitcherChange);
	}
}
</script>

<style scoped lang="scss">

</style>